import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import Slider from "react-slick";
import { compose } from "redux";
import { settingsSchool } from "../../athletes/AthleteDetails";

const AthletesStatsPhotos = (props) => {
  return (
    <>
      {props.stats && props.stats.length > 0 && (
        <div class="AthleteAwardsHonorsInfoContainer d-block">
        <div className="AdminFormPersonalInfoContainer mb-20">
          <h3>Stats/Measurables</h3>
          <Slider {...settingsSchool}>
            {props.stats.map((stat) => (
              <div className="slider-img">
                <img src={stat.url} alt="Athlete Thumbnail" />
              </div>
            ))}
          </Slider>
        </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  let id = null;
  let stats = [];
  const statsData = state.firestore.data.athletesStats;
  const athletesData = state.firestore.ordered.adminAthletes;
  if (
    athletesData &&
    athletesData.length > 0 &&
    statsData &&
    Object.keys(statsData).length > 0
  ) {
    id = athletesData[0].id;
    if (id) {
      if (
        statsData[id] &&
        Object.keys(statsData[id]).length > 0 &&
        statsData[id].stats &&
        statsData[id].stats.length > 0
      ) {
        stats = statsData[id].stats;
      }
    }
  }

  return {
    stats,
    auth: state.firebase.auth,
    add: state.statsPhotos.Add,
    adding: state.statsPhotos.Adding,
    error: state.statsPhotos.AddError,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    {
      collection: "athletesStats",
    },
    {
      collection: "adminAthletes",
      where: [["customUrl", "==", props.id]],
    },
  ])
)(AthletesStatsPhotos);
